export enum InventoryRuleStatus {
    PENDING = 'pending',
    PROCESSING = 'processing',
    COMPLETED = 'completed',
    FAILED = 'failed',
}

export interface InventoryRule {
    id: number;
    custom_key: string;
    custom_value: string;
    status: InventoryRuleStatus;
    error_message: string | null;
    created_at: string | null;
    updated_at: string | null;
}

export interface CreateInventoryRuleInput {
    custom_key: string;
    custom_value: string;
    network: string;
    status?: InventoryRuleStatus;
}

export interface CustomTargetingKey {
    id: string;
    name: string;
    displayName: string;
    type: string;
    status: string;
    network: string;
}

